export default __webpack_public_path__ + "static/media/Flag_of_Angola.afc346d0.svg";